import { render, staticRenderFns } from "./AwardTransformation.vue?vue&type=template&id=37b7a77f&"
import script from "./AwardTransformation.vue?vue&type=script&lang=js&"
export * from "./AwardTransformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports